import PersonalAbsences from './personal-absences'

export default PersonalAbsences
